import '../styles/index.scss';

import lazyload from './modules/lazyload';
import analytics from './modules/analytics';
import data from '../data/data.json';
import BarCode from './modules/barcode';

const charts = [];

window.addEventListener('load', () => {

  lazyload('.lazyload', {
    rootMargin: '100px',
    threshold: 0
  }).observe();

  analytics({
    serviceUrl: 'https://ddj.br.de/analytics/track',
    projectId: 'pestizide',
    tracker: {
      click: true,
      observer: true,
      timer: true,
      custom: true
    },
    respectDNT: true
  });

  charts.push(new BarCode({
    target: '#prosulfuron',
    data: data.filter(d => d.key === 'Prosulfuron')[0]
  }));
  charts.push(new BarCode({
    target: '#sulfosulfuron',
    data: data.filter(d => d.key === 'Sulfosulfuron')[0]
  }));
  charts.push(new BarCode({
    target: '#pyridate',
    data: data.filter(d => d.key === 'Pyridate')[0]
  }));

  resize();
});

function resize() {
  let timeout;

  window.onresize = () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      charts.forEach((chart) => {
        chart.update();
      });
    }, 200);
  };
}
